'use client';

import { Channel, BreakingNew } from '@/lib/model';
import { BreakingNewsClient } from './BreakingNewsClient';
import { useEffect, useState } from 'react';
import { getAPILocale } from '@/utils';

type Props = {
  channel: Channel;
};

export function BreakingWrapper({ channel }: Props) {
  const [breakingNews, setBreakingNews] = useState<BreakingNew[] | undefined>(
    undefined,
  );

  useEffect(() => {
    if (!channel?.id || !channel?.languageCode) return;

    const fetchNews = async () => {
      try {
        const response = await fetch(
          `/api/breaking-news?channelId=${channel.id}&languageCode=${getAPILocale(channel.languageCode)}`,
        );
        if (!response.ok) {
          // Handle HTTP errors, e.g., response.status
          console.error('Failed to fetch breaking news:', response.status);
          setBreakingNews(undefined);
          return;
        }
        const data = await response.json();
        setBreakingNews(data);
      } catch (error) {
        console.error('Error fetching breaking news:', error);
        setBreakingNews(undefined);
      }
    };

    fetchNews();
  }, [channel]);

  return (
    <BreakingNewsClient initialBreakingNews={breakingNews} channel={channel} />
  );
}
